import { IsoToEpochTime } from '../helpers';
import { ShowPhoto, ShowThumbnail, FocusOnPhoto, FocusOnPhotoGroup } from '../Event';

const kFocusDuration = 5000;
const kInDuration = 500;
const kOutDuration = 300;
const kPhotoHeight = 400;
const kScreenExtent = 0.9;
const kGroupThreshold = 60 * 1000;

// @TODO: This should just be a static SVG
const kThumbnailSize = 70;
const kDotSize = Math.round(kThumbnailSize * 0.16);
const kThumbnailCanvas = document.createElement('canvas');
const kDotCanvas = document.createElement('canvas');
const kTimerCanvas = document.createElement('canvas');
drawThumbnail(kThumbnailCanvas, kThumbnailSize);
drawDot(kDotCanvas, kDotSize);
drawTimer(kTimerCanvas);

const kTerrainProfileIcon = new Image();
kTerrainProfileIcon.src =
  'data:image/svg+xml;utf8,%3Csvg%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%20512%20512%22%20style%3D%22enable-background%3Anew%200%200%20512%20512%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cg%3E%0A%09%3Cpath%20d%3D%22M480%2C128H368l-23.156-46.312C339.422%2C70.848%2C328.344%2C64%2C316.223%2C64H195.777c-12.121%2C0-23.199%2C6.848-28.621%2C17.688L144%2C128%0A%09%09H32c-17.672%2C0-32%2C14.326-32%2C32v256c0%2C17.673%2C14.328%2C32%2C32%2C32h448c17.672%2C0%2C32-14.327%2C32-32V160C512%2C142.326%2C497.672%2C128%2C480%2C128z%0A%09%09%20M256%2C416c-70.691%2C0-128-57.308-128-128s57.309-128%2C128-128s128%2C57.308%2C128%2C128S326.691%2C416%2C256%2C416z%22%20fill%3D%22%23121212%22%2F%3E%0A%09%3Ccircle%20cx%3D%22256%22%20cy%3D%22288%22%20r%3D%2264%22%20fill%3D%22%23121212%22%2F%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3Cg%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A';

export default class Photo {
  async load(mediaItem) {
    const imageLoaded = new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => resolve(img);
      img.onerror = () => reject();
      img.src = mediaItem.source;
    });

    this.image = await imageLoaded;
    this.aspect = this.image.width / this.image.height;
    this.worldHeight = kPhotoHeight;
    this.targetId = mediaItem.target.activityId;
    this.targetTime = IsoToEpochTime(mediaItem.target.time);

    this.canvas = document.createElement('canvas');
  }

  onReady(worldPos, context) {
    this.worldPos = worldPos;
    this.name = this.image.src.substr(this.image.src.lastIndexOf('/') + 1);

    const state = context.store.getState();
    this.screenWidth = state.layout.width;
    this.screenHeight = state.layout.height;
    this.timerRect = {};
    drawFrame(this.canvas, this.image, state.layout, this.timerRect);

    // If this Photo occurs close to another Photo, and this to that Photo's group. Otherwise create a new group.
    const media = Object.keys(context.media).map(mediaId => context.media[mediaId]);
    const photos = media.filter(m => m.desc.mediaType === 'photo' && m.ready && m.obj !== this);
    const sibling = photos.find(p => {
      const dt = Math.abs(p.obj.targetTime - this.targetTime);
      return dt < kGroupThreshold;
    });
    this.group = sibling ? sibling.obj.group : new PhotoGroup(context);
    this.group.addPhoto(this);

    this.photoElem = context.hud.createElement(`Photo[${this.name}]`);
    this.photoElem.setCanvas(this.canvas);
    this.photoElem.setWorldHeight(this.worldHeight);
    this.photoElem.setShow(false);
    this.photoElem.setWorldPos(worldPos);

    this.timerElem = context.hud.createElement(`PhotoTimer[${this.name}]`);
    this.timerElem.setCanvas(kTimerCanvas);
    this.timerElem.setWorldHeight(this.worldHeight / this.canvas.height);
    this.timerElem.setShow(false);
    this.timerElem.setWorldPos(worldPos);
    this.timerElem.setAnchor(-1, -1);
    this.timerElem.setScaleX(this.timerRect.w);
    this.timerElem.setScaleY(this.timerRect.h);
    this.timerElem.setOffset(-this.canvas.width * 0.5 + this.timerRect.x, -this.canvas.height + this.timerRect.y);

    // Focus on this Photo when the track reaches it
    const focusOptions = { photo: this, duration: kFocusDuration, screenExtent: kScreenExtent };
    this.focusEvent = new FocusOnPhoto(focusOptions);
    context.events.add(this.focusEvent);

    // Show the full photo (instead of the thumbnail icon) when the Focus starts
    this.photoEvent = new ShowPhoto({ inDuration: kInDuration, outDuration: kOutDuration, photo: this });
    context.events.add(this.photoEvent, 'whileEventActive', { event: this.focusEvent });
  }

  update(context) {
    const isFocusing = this.focusEvent.active;
    if (isFocusing) {
      const state = context.store.getState();

      // Re-draw the image and border if the a resize or rotate has occurred
      if (state.layout.width !== this.screenWidth || state.layout.height !== this.screenHeight) {
        this.screenWidth = state.layout.width;
        this.screenHeight = state.layout.height;

        // Resize and redraw the canvas, then update the HUD element
        drawFrame(this.canvas, this.image, state.layout, this.timerRect);
        this.photoElem.setCanvas(this.canvas);
        this.timerElem.setWorldHeight(this.worldHeight / this.canvas.height);
        this.timerElem.setScaleX(this.timerRect.w);
        this.timerElem.setScaleY(this.timerRect.h);
        this.timerElem.setOffset(-this.canvas.width * 0.5 + this.timerRect.x, -this.canvas.height + this.timerRect.y);
      }
    }
  }

  destroy(context) {
    this.group.deletePhoto(this);

    context.events.remove(this.focusEvent);
    context.events.remove(this.photoEvent);

    if (this.photoElem) context.hud.removeElement(this.photoElem);
  }
}

class PhotoGroup {
  constructor(context) {
    this.photos = [];
    this.context = context;

    this.thumbnail = context.hud.createElement(`Thumbnail[${this.name}]`);
    this.thumbnail.setShow(false);
    this.thumbnail.setCanvas(kThumbnailCanvas);

    this.dotElem = context.hud.createElement(`Dot[${this.name}]`);
    this.dotElem.setShow(true);
    this.dotElem.setCanvas(kDotCanvas);
    this.dotElem.setZScale(0.9); // @NOTE: Give the dot a bit of bias so that it is displayed over the trail and terrain

    // Show the thumbnail until we hit the photo (hide it after the photo has been shown)
    this.thumbEvent = new ShowThumbnail({ duration: 800, thumbnail: this.thumbnail, dot: this.dotElem });
    this.thumbTriggerOptions = {
      beforeEpochTime: { epochTime: Infinity },
      onCameraProximity: { targetPos: undefined, distance: 10000 },
    };
    context.events.add(this.thumbEvent, 'and', this.thumbTriggerOptions);

    this.focusEvent = new FocusOnPhotoGroup({ photos: this.photos });
    this.focusTriggerOptions = { epochTime: undefined };
    context.events.add(this.focusEvent, 'atEpochTime', this.focusTriggerOptions);

    this.profileElement = context.terrainProfile.addElement(kTerrainProfileIcon);
  }

  addPhoto(photo) {
    this.photos.push(photo);

    // Sort so that the earliest trigger time comes first
    this.photos.sort((a, b) => a.targetTime - b.targetTime);

    // Regenerate the thumbnail to include a count if necessary
    if (this.photos.length > 1) {
      const thumbCanvas = document.createElement('canvas');
      drawThumbnail(thumbCanvas, kThumbnailSize, this.photos.length);
      this.thumbnail.setCanvas(thumbCanvas);
    }

    // Update the trigger time to be the earliest of all the photos
    const primary = this.photos[0];
    this.thumbTriggerOptions.beforeEpochTime.epochTime = primary.targetTime;
    this.thumbTriggerOptions.onCameraProximity.targetPos = primary.worldPos;
    this.focusTriggerOptions.epochTime = primary.targetTime;
    this.thumbnail.setWorldPos(primary.worldPos);
    this.dotElem.setWorldPos(primary.worldPos);

    this.profileElement.trackId = primary.targetId;
    this.profileElement.time = primary.targetTime;
  }

  deletePhoto(photo) {
    const idx = this.photos.indexOf(photo);
    if (idx !== -1) this.photos.splice(idx, 1);

    if (this.photos.length <= 0) {
      this.context.events.remove(this.thumbEvent);
      this.context.events.remove(this.focusEvent);

      this.context.hud.removeElement(this.thumbnail);
      this.context.hud.removeElement(this.dotElem);
    }
  }
}

function drawThumbnail(canvas, size, count) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  const kUnit = size * 0.01;

  const kBorder = 10 * kUnit;
  const kPointerHeight = 16 * kUnit;

  canvas.width = size;
  canvas.height = size + kPointerHeight;

  // Styles
  ctx.strokeStyle = 'white';
  ctx.fillStyle = 'white';

  // Draw the frame
  ctx.lineWidth = kBorder;
  ctx.strokeRect(kBorder * 0.5, kBorder * 0.5, size - kBorder, size - kBorder);

  // Draw the pointer
  ctx.beginPath();
  ctx.moveTo(canvas.width * 0.5 - kPointerHeight * 0.5, size);
  ctx.lineTo(canvas.width * 0.5 + kPointerHeight * 0.5, size);
  ctx.lineTo(canvas.width * 0.5, canvas.height);
  ctx.closePath();
  ctx.fill();

  if (count) {
    ctx.font = '30px Verdana';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(count.toString(), size * 0.5, size * 0.5);
  }
}

function drawDot(canvas, size) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  canvas.width = size;
  canvas.height = size;
  ctx.fillStyle = 'white';

  // Draw the pointer (should match the pointer in drawThumbnail)
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(size, 0);
  ctx.lineTo(size * 0.5, size);
  ctx.closePath();
  ctx.fill();
}

function drawTimer(canvas) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  canvas.width = 1;
  canvas.height = 1;
  ctx.fillStyle = 'red';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
}

function drawFrame(canvas, img, layout, timerRect) {
  const ctx = canvas.getContext('2d');

  // Set the Photo "unit" to be 1% of the total screen real-estate that it will occupy (in the smaller dimension)
  const kUnit = kScreenExtent * Math.min(layout.width, layout.height) * 0.01;

  const kTimerHeight = kUnit * 0.6;
  const kBorder = 2 * kUnit;
  const kBottomBorder = 4 * kUnit + kTimerHeight;
  const kImagePadding = kUnit;
  const kPointerHeight = 1.4 * kUnit;
  const kCornerRadius = 4;
  const kShadowWidth = 2;

  // Derived values. These offsets refer to the distance between the edge of the canvas and the start of an element.
  const imgOff = kShadowWidth + kCornerRadius + kBorder + kImagePadding;
  const imgOffBottom = kShadowWidth + kPointerHeight + kCornerRadius + kBottomBorder + kImagePadding;
  const paddingOff = imgOff - kImagePadding - kCornerRadius;
  const paddingOffBottom = imgOffBottom - kImagePadding - kCornerRadius;
  const borderOff = kShadowWidth + kCornerRadius;
  const borderOffBottom = kShadowWidth + kPointerHeight + kCornerRadius;
  const pointerOffBottom = kShadowWidth;

  // Compute the largest possible resolution for our image if it were to fill the screenExtent, including the border
  const imgAspect = img.width / img.height;
  const maxImgDimX = layout.width * kScreenExtent - 2 * imgOff;
  const maxImgDimY = layout.height * kScreenExtent - (imgOff + imgOffBottom);

  // Use the smaller of these dimensions to size the image. The aspect determines the other dimension.
  const imgWidth = Math.min(maxImgDimX, maxImgDimY * imgAspect);
  const imgHeight = Math.min(maxImgDimY, maxImgDimX / imgAspect);

  // The size of the canvas then depends on the image size plus the border and padding
  canvas.width = imgWidth + 2 * imgOff;
  canvas.height = imgHeight + (imgOff + imgOffBottom);

  // Styles
  ctx.lineWidth = kCornerRadius * 2.0;
  ctx.lineJoin = 'round';
  ctx.strokeStyle = 'white';
  ctx.fillStyle = 'white';
  ctx.shadowColor = 'black';
  ctx.shadowBlur = 2;

  // Draw the triangle pointer
  ctx.beginPath();
  ctx.moveTo(canvas.width * 0.5 - borderOffBottom * 0.9, canvas.height - borderOffBottom);
  ctx.lineTo(canvas.width * 0.5 + borderOffBottom * 0.9, canvas.height - borderOffBottom);
  ctx.lineTo(canvas.width * 0.5, canvas.height - pointerOffBottom);
  ctx.closePath();
  ctx.fill();

  // Define the outside of the frame...
  ctx.beginPath();
  ctx.moveTo(borderOff, borderOff);
  ctx.lineTo(canvas.width - borderOff, borderOff);
  ctx.lineTo(canvas.width - borderOff, canvas.height - borderOffBottom);
  ctx.lineTo(borderOff, canvas.height - borderOffBottom);
  ctx.closePath();

  // ... and the inside of the frame
  ctx.moveTo(paddingOff, paddingOff);
  ctx.lineTo(paddingOff, canvas.height - paddingOffBottom);
  ctx.lineTo(canvas.width - paddingOff, canvas.height - paddingOffBottom);
  ctx.lineTo(canvas.width - paddingOff, paddingOff);
  ctx.closePath();

  // Draw the outlines of the frame with drop shadow
  ctx.stroke();

  // Fill the inside of the frame
  ctx.shadowBlur = 0;
  ctx.fill();

  // Fill an extended pointer triangle to clear the drop shadow that was drawn on top by the frame
  ctx.beginPath();
  ctx.moveTo(canvas.width * 0.5 - borderOffBottom * 0.9, canvas.height - borderOffBottom);
  ctx.lineTo(canvas.width * 0.5 + borderOffBottom * 0.9, canvas.height - borderOffBottom);
  ctx.lineTo(canvas.width * 0.5, canvas.height - pointerOffBottom);
  ctx.closePath();
  ctx.fill();

  // Draw the timer line background
  ctx.fillStyle = 'grey';
  timerRect.x = imgOff - kImagePadding;
  timerRect.y = canvas.height - paddingOffBottom - kCornerRadius;
  timerRect.w = imgWidth + kImagePadding * 2;
  timerRect.h = kTimerHeight;
  ctx.fillRect(timerRect.x, timerRect.y, timerRect.w, timerRect.h);

  // Draw the image kImagePadding pixels away from the top left border corner
  ctx.drawImage(img, imgOff, imgOff, imgWidth, imgHeight);

  return canvas;
}
